import React from 'react';

const Faq = () => {
  return (
    <div className="container" style={{ maxWidth: '800px', margin: '20px auto', padding: '20px' }}>
      <h1>Frequently Asked Questions</h1>

      <h2>What is ASMR?</h2>
      <p>ASMR stands for Autonomous Sensory Meridian Response. It&apos;s a tingling sensation that typically begins on the scalp and moves down the back of the neck and upper spine. People often describe it as a pleasant, relaxing feeling triggered by certain sounds, visuals, or experiences.</p>

      <h2>How do I use ASMR.guru?</h2>
      <p>Simply browse through our curated collections of ASMR videos on the home page. Click on any video thumbnail to watch it. You can explore different categories like #forsleep, #satisfying, #tingles, and more.</p>

      <h2>Are all videos on ASMR.guru free to watch?</h2>
      <p>Yes! All videos are embedded from YouTube and are free to watch. We simply curate and organize them for easier discovery.</p>

      <h2>How often is content updated?</h2>
      <p>We regularly update our video collections to bring you the latest and best ASMR content from talented creators.</p>

      <h2>Can I request a specific video or creator to be featured?</h2>
      <p>Yes! Please use our contact page to send us your suggestions.</p>

      <h2>Do you have a mobile app?</h2>
      <p>Currently, ASMR.guru is a web-based platform that works great on mobile browsers. We&apos;re always exploring ways to improve the mobile experience.</p>

      <h2>I&apos;m an ASMR creator. How can I get my videos featured?</h2>
      <p>We&apos;d love to feature your content! Please reach out through our contact page with information about your channel.</p>

      <h2>Why isn&apos;t a video playing?</h2>
      <p>If a video isn&apos;t playing, it may have been removed from YouTube or set to private by the creator. Try refreshing the page or selecting another video.</p>
    </div>
  );
};

export default Faq;